import { normalizeValue } from './normalizeValue';

export function lowerCaseValue(value: string | undefined): string | undefined {
	const trimmed = normalizeValue(value);
	if (!trimmed) {
		return undefined;
	}

	return trimmed.toLocaleLowerCase('en-US');
}
